'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = PopupButton;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ClickableComponent = require('../ClickableComponent');

var _ClickableComponent2 = _interopRequireDefault(_ClickableComponent);

var _Popup = require('./Popup');

var _Popup2 = _interopRequireDefault(_Popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  inline: _react.PropTypes.bool,
  onClick: _react.PropTypes.func.isRequired,
  onFocus: _react.PropTypes.func,
  onBlur: _react.PropTypes.func,
  className: _react.PropTypes.string
};

var defaultProps = {
  inline: true
};

function PopupButton(props) {
  var inline = props.inline,
      className = props.className;

  var ps = _extends({}, props);
  delete ps.children;
  delete ps.inline;
  delete ps.className;
  return _react2.default.createElement(
    _ClickableComponent2.default,
    _extends({
      className: (0, _classnames2.default)(className, {
        'video-react-menu-button-inline': !!inline,
        'video-react-menu-button-popup': !inline
      }, 'video-react-control video-react-button video-react-menu-button')
    }, ps),
    _react2.default.createElement(_Popup2.default, props)
  );
}

PopupButton.propTypes = propTypes;
PopupButton.defaultProps = defaultProps;


/*****************
 ** WEBPACK FOOTER
 ** ./~/video-react/lib/components/popup/PopupButton.js
 ** module id = 1239
 ** module chunks = 0
 **/